<h1 mat-dialog-title>
  @if (documentIdentifier) {
    {{ 'labels.heading.Add Client Identifier' | translate }}
  } @else {
    {{ 'labels.heading.Upload' | translate }} {{ entityType }} {{ 'labels.heading.Documents' | translate }}
  }
</h1>
<div class="m-l-10 m-r-10">
  <form [formGroup]="uploadDocumentForm" class="layout-column">
    <!-- Identity-specific fields -->
    @if (documentIdentifier) {
      <mat-form-field class="flex-fill">
        <mat-label>{{ 'labels.inputs.Document Type' | translate }}</mat-label>
        <mat-select formControlName="documentTypeId" required>
          @for (docType of allowedDocumentTypes; track docType) {
            <mat-option [value]="docType.id">
              {{ docType.name }}
            </mat-option>
          }
        </mat-select>
        @if (uploadDocumentForm.controls.documentTypeId?.hasError('required')) {
          <mat-error>
            {{ 'labels.inputs.Document Type' | translate }} {{ 'labels.commons.is' | translate }}
            <strong>{{ 'labels.commons.required' | translate }}</strong>
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="flex-fill">
        <mat-label>{{ 'labels.inputs.Status' | translate }}</mat-label>
        <mat-select formControlName="status" required>
          @for (status of statusOptions; track status) {
            <mat-option [value]="status.value">
              {{ status.label }}
            </mat-option>
          }
        </mat-select>
        @if (uploadDocumentForm.controls.status?.hasError('required')) {
          <mat-error>
            {{ 'labels.inputs.Status' | translate }} {{ 'labels.commons.is' | translate }}
            <strong>{{ 'labels.commons.required' | translate }}</strong>
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="flex-fill">
        <mat-label>{{ 'labels.inputs.Document Key' | translate }}</mat-label>
        <input formControlName="documentKey" required matInput />
        @if (uploadDocumentForm.controls.documentKey?.hasError('required')) {
          <mat-error>
            {{ 'labels.inputs.Document Key' | translate }} {{ 'labels.commons.is' | translate }}
            <strong>{{ 'labels.commons.required' | translate }}</strong>
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="flex-fill">
        <mat-label>{{ 'labels.inputs.Description' | translate }}</mat-label>
        <input formControlName="description" matInput />
      </mat-form-field>
    }

    <mat-form-field class="flex-fill">
      <mat-label>{{ 'labels.inputs.File Name' | translate }}</mat-label>
      <input formControlName="fileName" required matInput />
      @if (uploadDocumentForm.controls.fileName.hasError('required')) {
        <mat-error>
          {{ 'labels.inputs.File Name' | translate }} {{ 'labels.commons.is' | translate }}
          <strong>{{ 'labels.commons.required' | translate }}</strong>
        </mat-error>
      }
    </mat-form-field>

    @if (!documentIdentifier) {
      <mat-form-field class="flex-fill">
        <mat-label>{{ 'labels.inputs.Description' | translate }}</mat-label>
        <input formControlName="description" matInput />
      </mat-form-field>
    }

    <LOSx-file-upload flex="60%" (change)="onFileSelect($event)"></LOSx-file-upload>

    <mat-dialog-actions align="end">
      <button mat-raised-button mat-dialog-close>{{ 'labels.buttons.Cancel' | translate }}</button>
      <button
        mat-raised-button
        color="primary"
        [disabled]="!uploadDocumentForm.valid"
        [mat-dialog-close]="uploadDocumentForm.value"
      >
        @if (documentIdentifier) {
          {{ 'labels.buttons.Add' | translate }}
        } @else {
          {{ 'labels.buttons.Upload' | translate }}
        }
      </button>
    </mat-dialog-actions>
  </form>
</div>
